module.exports = __webpack_public_path__ + "img/剪切.848c77dd.svg";